import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import jsPDF from 'jspdf';

const winHeight = parseInt(window.innerHeight);
const winWidth = parseInt(window.innerWidth);

const getHeightTableMain= (movil, _this)=>{

  const getHeight = ()=>{ 
    
    if (!movil)
      return winHeight < window.innerHeight ? window.innerHeight : winHeight;
    else{ 
      if (winHeight > winWidth)
       return winHeight;
      
      return winWidth;
    }

  }

  const height = getHeight();
  const x = height - _this.tablaRef.current.getBoundingClientRect().top - 5;
  
  if (!movil)
    return { heightTable: x, heightScreen: height };
  else 
    return { heightTable: (x < 500) ? 500 : parseInt(x), heightScreen: height };

}

const getHeightTableDialog=(movil, refTable, refDialogAction, valSeparation)=>{

  const topTable = refTable.current.getBoundingClientRect().top;
  const topDialogAction = refDialogAction.current.getBoundingClientRect().top + (winHeight - parseInt(window.innerHeight));
  valSeparation = valSeparation === undefined ? 10 : valSeparation;

  if (!movil)
    return parseInt(topDialogAction - topTable - valSeparation);
    
  if (winHeight > winWidth)
    return parseInt(topDialogAction - topTable - valSeparation);
  
  return parseInt(winWidth - topTable - 80);

}

const getTime = (strDate, outOption)=>{

 let _date = strDate.substr(8,2) + '/' + strDate.substr(5,2) + '/' + strDate.substr(0,4);
 let _time = (parseInt(strDate.substr(11, 2)) > 12) ?  (parseInt(strDate.substr(11, 2)) - 12).toString().padStart(2, 0) + strDate.substr(13, 3)  + ' p.m.' :
                  (parseInt(strDate.substr(11, 2)) === 12) ? strDate.substr(11, 2) + strDate.substr(13, 3) + ' p.m.' :
                    (parseInt(strDate.substr(11, 2)) === 0) ? '12' + strDate.substr(13, 3) + ' a.m.' : strDate.substr(11, 5) + ' a.m.';
                  
 if (outOption === 0)
 {
   return _date;
 }
 else if (outOption === 1)
 {
   return _time;
 }
    
 return _date + ', ' + _time;
    
}

const onlyNumbers = (ref, disabledZeroFirst, isValueNumber, decimal) => (ev) =>
{
  
  const keyCode = ev.which || ev.keyCode;
  const key = ev.key;
  
  if (isValueNumber && decimal && ref.current.value.length > 0 && !ref.current.value.includes('.') && key ==='.' && (keyCode === 110 ||  keyCode === 190))
  { 
    return true;
  }

  if (isValueNumber && ref.current.value.length === 1 && parseInt(ref.current.value) === 0 && !isNaN(parseInt(key)))
  {
     ref.current.value = '';
  }

  
  if (disabledZeroFirst && ref.current.value.length === 0 && (keyCode === 48 || keyCode === 96))
  {
    ev.preventDefault();
    return false;
  }
          
  if (isNaN(parseInt(key)) && keyCode !== 8 && keyCode !== 9 && keyCode !== 46 && keyCode !== 37 && keyCode !== 39) //Excepciones: Tab, Backspace, Supr 
  {
    ev.preventDefault();
    return false;
  }

  return true;

}

const splitWords = (valueBegin, valueEnd, text)=>{

  let words = '';
  let countValueBegin = 0;
  let arrayLastLetters = [];
  let lettersTmp = '';
  
  for (let j = 0; j < text.length; j++)
  {
      if (text.substr(j, 1).trim().length === 0)
      {
        if (countValueBegin < valueBegin)
        {
          words = words + ' ';
          countValueBegin++;
        }
        else 
        {
           arrayLastLetters.push(lettersTmp);
           lettersTmp = '';
        }
        
      }
      else if (countValueBegin < valueBegin)
      {
        words = words + text.substr(j, 1);
      }
      else 
      {
        lettersTmp = lettersTmp + text.substr(j, 1);
      }
  
      if (j + 1 === text.length)
      {
        arrayLastLetters.push(lettersTmp);
      }
  
  }
  
  
  if (countValueBegin === valueBegin)
  {
      if (arrayLastLetters.length >= valueEnd)
      {
          words = arrayLastLetters.length > valueEnd ? words.trim() + '...' : words;
          
          for (let k=0; k<valueEnd; k++)
          {
              words = k===0 ? words + arrayLastLetters[arrayLastLetters.length - (valueEnd - k)] : words + ' ' + arrayLastLetters[arrayLastLetters.length - (valueEnd - k)];
          }
      }
      else
      {
         words = text;
      }
  }
  else 
  {
     words = text;
  }
  
  return words;
  
}

const refreshTable = (process, currentRows, currentGroups, row, nameID, groupColumn1, oldLabelGroup1, groupColumn2, oldLabelGroup2)=>{
  
  const addRowTable = (rows, row)=>{

        if (groupColumn1 !== undefined)
        {   
           let __currentRows = rows.filter(x => x[groupColumn1] !== row[0][groupColumn1]);
           let __currentRowsGroup = rows.filter(x => x[groupColumn1] === row[0][groupColumn1]);

           if (groupColumn2 !== undefined)
           { 
              let __currentRowsSubGroups = __currentRowsGroup.filter(x => x[groupColumn2] !== row[0][groupColumn2]);
              let __currentRowsSubGroups_ = __currentRowsGroup.filter(x => x[groupColumn2] === row[0][groupColumn2]);
              
              return __currentRows.concat(__currentRowsSubGroups).concat(__currentRowsSubGroups_).concat(row);              
           
            }

            return __currentRows.concat(__currentRowsGroup).concat(row);

        }

        return rows.concat(row); 
  }

  const removeRowTable = (id, nameID, rows) =>{

    return rows.filter(x => x[nameID] !== id);
  }

  let labelGroup1 = row[0][groupColumn1] === null ? 'null' : row[0][groupColumn1] === true ? 'true' : row[0][groupColumn1] === false ? 'false' : row[0][groupColumn1];
  let labelGroup2 = row[0][groupColumn2] === null ? 'null' : row[0][groupColumn2] === true ? 'true' : row[0][groupColumn2] === false ? 'false' : row[0][groupColumn2];
  let __currentRows = Object.assign([], currentRows);
  let __currentGroups = Object.assign([], currentGroups);
  let __moveScroll = false;

  if (process < 3 && labelGroup1 !== undefined && !__currentGroups.find(x => x === labelGroup1))
  {
      __currentGroups.push(labelGroup1);
  }

  if (process < 3 && labelGroup2 !== undefined && !__currentGroups.find(x => x === labelGroup1 + '|' + labelGroup2))
  {
    __currentGroups.push(labelGroup1 + '|' + labelGroup2);
  }

  if (process === 1)
  {
     __currentRows = addRowTable(currentRows, row);
     __moveScroll = true;
  }
  else if (process === 2)
  {   
      let tmpRows = [];

      if (row[0][groupColumn1] === oldLabelGroup1 && row[0][groupColumn2] === oldLabelGroup2)
      {
        tmpRows = __currentRows.map((item)=>{ 
                                      if (item[nameID] === row[0][nameID])
                                      { 
                                        item = row[0];
                                      }
                                      return item;
                                    });
        
        __currentRows = tmpRows;
      }
      else
      {
          tmpRows = removeRowTable(row[0][nameID], nameID, currentRows);
          __currentRows = addRowTable(tmpRows, row);
          __moveScroll = true;
      }

  }
  else if (process === 3)
  {
    __currentRows = removeRowTable(row[0][nameID], nameID, currentRows);
  }
  
  return {refreshRows: __currentRows, refreshGroups: __currentGroups, moveScroll: __moveScroll }
  
}

const showToast = (type, text, onClick, onHidden)=>
{

const movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

toastr.options = {
                  closeButton: true,
                  newestOnTop: false,
                  debug: false,
                  onclick: onClick,
                  onHidden: onHidden,
                  timeOut: 18000,
                  showDuration: 20,
                  positionClass: movil ? "toast-top-full-width" : "toast-top-right"            
                 }

switch (type.toLowerCase()) { 

  case 'i':
    toastr.info(text, 'Información');
    break;
  case 's':
    toastr.success(text, 'Correcto');
    break;  
  case 'w':
    toastr.warning(text, 'Advertencia');
    break;
  case 'e':
    toastr.error(text, 'Error');
    break;
  default:
    break;  
}

}

const getDateSelect = (date)=>{

  return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2,"0") + '-' + date.getDate().toString().padStart(2,"0");

}

const getTimeSelect = (hours, minutes, meridian, dateFormated) =>{

  const tmpVal = meridian === 1 ?  parseInt(hours) < 12 ? (parseInt(hours) + 12).toString() : hours
                                : parseInt(hours) === 12 ? '00' : hours;
  
  return dateFormated !== undefined ? dateFormated + 'T' + tmpVal + ':' + minutes + ':00.000'
                                    : tmpVal + ':' + minutes + ':00.000';
  
}

const getIdRowChecking = (arrayTable, arrayState)=>{

  let value;
  
  if (arrayTable.length > arrayState.length)
  {
    
    arrayTable.map((item, index)=>{
      if (!arrayState.find(x => x === item))
      {
        value = item;
      }
     return item   
    });
  
  }
  else if (arrayState.length > arrayTable.length)
  {  
    arrayState.map((item, index)=>{
      if (!arrayTable.find(x => x === item))
      {
        value = item;
      }
     return item   
    });
  
  }
  
  return value;
  
}

const getTimeParcial =(dateDB, optionParcial, valueDefault)=>{

  if (dateDB === null || dateDB === undefined){
    return valueDefault !== undefined ? optionParcial.toUpperCase()==="H" ? valueDefault : 
                                        optionParcial.toUpperCase()==="M" ? valueDefault :
                                        optionParcial.toUpperCase()==="T" ? valueDefault 
                                        : null
                                      : null;
  }
  
  let hourTmp = parseInt(dateDB.toString().substring(11,13));
  
  if (optionParcial.toUpperCase()==="H")
  {
     return hourTmp > 12 ? (hourTmp - 12).toString().padStart(2,"0") : hourTmp === 0 ? '12' : hourTmp.toString().padStart(2,"0");
  }
  
  if (optionParcial.toUpperCase()==="M")
  {
     return dateDB.toString().substring(14,16);
  }
  
  if (optionParcial.toUpperCase()==="T")
  {
    return hourTmp >= 12 ? 1 : 0;
  }
  
  
}

const formatCurrency = (value)=>{

  if (isEmpty(value)) return null;

  return value.toLocaleString('es-HN', {minimumFractionDigits: 2}); //{style: 'currency',currency: 'L', }
 
}

const getDetailTime =(strDates)=>{

  let strResp = "";
  let day = null;
  let hours = [];
 
  strDates.split("/n").map((item)=>{    
 
   day = item.substring(0,1);
   item = item.replace("(", "").replace(")", "").substring(1, item.length - 1);
   hours = item.split(".");
   
   strResp = strResp + day + " (" + getTime(hours[0], 1) + " - " + getTime(hours[1], 1) + ")\n";
 
   return item;
  });
 
  return strResp;
 
}

const isEmpty = (value)=>{

  if (value === undefined || value === null || value.toString().trim().length === 0){
    return true;
  }
  
  return false;
  
}

const crearReciboPdf = (factura, fechaPago, fecha, recibo, cuenta, nombre, plan, rows, total, recibido, cambio, usuario, movil, callback)=>{
  var doc = new jsPDF('p', 'mm', [63.5, 210]);  
  const pageWidth = doc.internal.pageSize.getWidth();
  let x = 8;
  let y= 8;

  doc.setFont("helvetica");
  doc.setFontSize(8);
  doc.setFont(undefined, "bold");
  doc.text('Universidad de San Pedro Sula', pageWidth / 2, y, "center");
  y += 8;
  doc.setFontSize(7);
  doc.text('Fecha de pago', x, y);
  doc.setFont(undefined, "normal");
  doc.text(fechaPago, x + 20, y);
  y += 5;
  doc.setFont(undefined, "bold");
  doc.text('Fecha de impresión', x, y);
  doc.setFont(undefined, "normal");
  doc.text(fecha, x + 26, y);
  y += 5;
  doc.setFont(undefined, "bold");
  doc.text('Nº recibo', x, y);
  doc.setFont(undefined, "normal");
  doc.text(recibo, x + 14, y);
  y += 5;
  doc.setFont(undefined, "bold");
  doc.text('Cuenta', x, y);
  doc.setFont(undefined, "normal");
  doc.text(cuenta, x + 12, y);
  y += 5;
  doc.setFont(undefined, "bold");
  doc.text('Nombre', x, y);
  doc.setFont(undefined, "normal");
  const _name = doc.splitTextToSize(nombre, 38); 
  doc.text(_name, x + 12, y);
  y += (5 + ((_name.length - 1) * 2.5)) //mm
  doc.setFont(undefined, "bold");
  doc.text('Plan', x, y);
  doc.setFont(undefined, "normal");
  const _plan = doc.splitTextToSize(plan, 42); 
  doc.text(_plan, x + 8, y);
  y += (8 + ((_plan.length - 1) * 2.5)); 
  doc.setFont(undefined, "bold");
  doc.text('Descripción', x, y);
  doc.text('Monto', x + 42, y);
  y += 2;
  doc.line(x, y, 57, y);
  y += 4;
  doc.setFont(undefined, "normal"); 

  rows.map((item)=>{ 
    const _descrip = doc.splitTextToSize(item.DESCRIPCION.trim(), 34); 
    doc.text(_descrip, x, y);
    y += (_descrip.length - 1) * 3;
    doc.text(item.Simbolo + formatCurrency(item.MONTO_TOTAL), (pageWidth / 2) + 25, y, "right"); 
    y += 4;
    return item;
  });

  doc.setFont(undefined, "bold");
  doc.line(x, y, 57, y);
  y += 4;
  doc.text('Total a pagar', (pageWidth / 2) + 3, y, "right");
  doc.text(total, (pageWidth / 2) + 25, y, "right");
  y += 3;
  doc.setFont(undefined, "normal");
  doc.text('Recibido', (pageWidth / 2) + 3, y, "right");
  doc.text(recibido, (pageWidth / 2) + 25, y, "right");
  y += 3;
  doc.text('Cambio', (pageWidth / 2) + 3, y, "right");
  doc.text(cambio, (pageWidth / 2) + 25, y, "right");
  y += 18;
  doc.setFont(undefined, "bold");
  doc.text(usuario, pageWidth / 2, y, "center");
  y += 3;
  doc.text('Departamento de Cobros', pageWidth / 2, y, "center");
  y += 5;
  doc.text(' ', pageWidth / 2, y, "center");

  if (movil){
   doc.save("USAP-Recibo-" + String(factura)); 
   callback();
   return;
  }

  doc.autoPrint({variant: "non-conform"});

  const frame = document.getElementById("iFram3Recib0"); 
  if (frame !== null)
  document.body.removeChild(frame);

  const hiddFrame = document.createElement("iframe");
  hiddFrame.style.position = 'fixed';
  hiddFrame.style.width = '1px';
  hiddFrame.style.height = '1px';
  hiddFrame.style.opacity = '0.01';  
  hiddFrame.id = "iFram3Recib0";
  const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
   if (isSafari) {
    // fallback in safari
    hiddFrame.onload = () => {
      try {
        hiddFrame.contentWindow.document.execCommand('print', false, null);
      } catch (e) {
        hiddFrame.contentWindow.print();
      }
      callback();
    };
  }
  else {
    hiddFrame.onload = callback;
  }
  hiddFrame.src = doc.output('bloburl'); 
  document.body.appendChild(hiddFrame);
  
}

function obtener_dia(dia){
  var dia_palabra;
  switch (dia) {
    case 1: dia_palabra='Domingo'; break;
    case 2: dia_palabra='Lunes'; break;
    case 3: dia_palabra='Martes'; break;
    case 4: dia_palabra='Miércoles';  break;
    case 5: dia_palabra='Jueves';  break;
    case 6: dia_palabra='Viernes';  break;
    case 7: dia_palabra='Sábado'; break;
    default:  break;
  }
  return dia_palabra;
}

function obtener_mes(mes){
  var mes_palabra;
  switch (mes) {
    case 1: mes_palabra='Enero'; break;
    case 2: mes_palabra='Febrero'; break;
    case 3: mes_palabra='Marzo'; break;
    case 4: mes_palabra='Abril';  break;
    case 5: mes_palabra='Mayo';  break;
    case 6: mes_palabra='Junio';  break;
    case 7: mes_palabra='Julio'; break;
    case 8: mes_palabra='Agosto';  break;
    case 9: mes_palabra='Septiembre';  break;
    case 10: mes_palabra='Octubre';  break;
    case 11: mes_palabra='Noviembre';  break;
    case 12: mes_palabra='Diciembre';  break;
    default:  break;
  }
  return mes_palabra;
}

export const globales={
    ip: 'https://siga.usap.edu/api',//PRUEBA: https://melioris.usap.edu/api PRODUCCION: https://siga.usap.edu/api
   // ip: 'https://siga.usap.edu/api',//
 
    border_dialog: 10,
    correo_soporte:'soporteit@usap.edu',
    //FLEMUS START
    redesSociales:{
        facebook:'https://www.facebook.com/USAPhn',
        twitter:'https://twitter.com/usaphn',
        instagram:'https://www.instagram.com/usaphn',
        tiktok :'https://www.tiktok.com/@usaphn',
        snapchat:'',
        youtube:'https://www.youtube.com/user/USAPhn',
        linkedin:'https://www.linkedin.com/school/universidad-de-san-pedro-sula/?viewAsMember=true',
    },
    enlacesMenu:{
        usap:'http://www.usap.edu/',
        admisiones:'https://admision.usap.edu',//'https://melioris.usap.edu/admision',//'http://172.21.12.187:3000/admision',//'http://pruebasiga.usap.edu/admision',//'http://172.21.10.18:3000/admision',
        contactanos:'https://www.usap.edu/contacto',
        campusVirtual:'https://virtual.usap.edu/',
        recorridoVirtual:'https://www.usap.edu/estudiantes/instalaciones/',
        sugerencias:'https://consultas.usap.edu/',
    },
    claveApiGoogle:'985092142154-9jsdb35p4mdv89g49l16dneivq75piid.apps.googleusercontent.com',//melioris@usap.edu
    //claveApiGoogle:'752569011321-pqgqi3kocsj05cqsm4022ma5g06sbkva.apps.googleusercontent.com',//'453604797969-ucs2fvgbgnqf4p05cler0qg7a9a3f4fn.apps.googleusercontent.com',
    dominioCorreo: '@usap.edu',
    checkout_public_:'checkout_public_J69fMpSeF596666pz6JNZApjBt8Van8q',
    //FLEMUS END
    tabla:{
        marginleft: 15,
        marginright:15,
        marginleft_movil:5,
        marginright_movil:5,
    },
    menu:{
      url_moodle: 'https://virtual.usap.edu/login'
    },
}
export const colores={
    azul: '#00336A',//'#0057B7',
    azul_rgb: '0,51,106', //'0,87,183',
    naranja: '#ff7300',
    naranja_rgb: '255,115,0',
    menu:{
        sombra:'252,239,227',
        letra:'#ff7300',
        degradado:'1',
	color_icono_modulo: 'rgba(0,51,106,0.8)',//'#DC9554',
    },
    tabla:{
        selection:'224, 224, 235, 0.9',
        encabezado: '#00336A',//'#0057B7', //'0,87,183,1',
	      alternateColorRow1:'#EBF5FB',
        alternateColorRow2:'white',
        color_iconos: 'white',
	      color_iconos_SL: '#bdbdbd',
        color_iconos_SL_: '#f8d210',
    },
    color_disabled: '#bdbdbd',
    color_inactive: '#808080',
}

export var pendientes_alumno={
  matricula: null,
  cuotas: null,
  toda_factura:null,
}

export var usuario={
  like: null,
}

export const funciones = {
    getHeightTableMain,
    getHeightTableDialog,
    getTime,
    onlyNumbers,
    splitWords,
    refreshTable,
    showToast,
    getDateSelect,
    getTimeSelect,
    getIdRowChecking,
    getTimeParcial,
    obtener_dia,
    obtener_mes,
    formatCurrency,
    getDetailTime,
    isEmpty,
    crearReciboPdf,
}
